
    <div class="main-section-wrapper container">
        <h2 class="text-2xl font-bold">{{ dataSource.Title }}</h2>
        <div class="flex items-stretch md:grid md:grid-cols-2 lg:grid-cols-3 overflow-x-auto x-scroll gap-6 md:overflow-x-hidden">
            <ng-container *ngFor="let item of dataSource?.Section?.Data?.Details">
                <iho-residences-card [dataSource]="item" />
            </ng-container>
        </div>
    </div>
